module.exports = __webpack_public_path__ + "static/baileywithmike-045fcc966e6fc40e7cd27e1aba2e26c3.jpg";